module.exports = __webpack_public_path__ + "static/media/undraw_floating_61u6.186a1676.svg";